import { render, staticRenderFns } from "./StageCard.vue?vue&type=template&id=52264b07&scoped=true"
var script = {}
import style0 from "./StageCard.vue?vue&type=style&index=0&id=52264b07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52264b07",
  null
  
)

export default component.exports